"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("../_internals/functions");
const Union_1 = require("../Union");
const union_1 = __importDefault(require("../Union/union"));
const symbols_1 = require("../_internals/symbols");
const Async_1 = __importDefault(require("../Async"));
const EitherType = () => (cases, globals) => {
    function getImpl() {
        return (0, symbols_1.getInnerValue)(this);
    }
    ;
    cases.Right.prototype.get = getImpl;
    cases.Left.prototype.get = getImpl;
    cases.Right.prototype.getEither = getImpl;
    cases.Left.prototype.getEither = getImpl;
    function getRightImpl() {
        return this.isRight() ? (0, symbols_1.getInnerValue)(this) : undefined;
    }
    ;
    cases.Right.prototype.getRight = getRightImpl;
    cases.Left.prototype.getRight = getRightImpl;
    function getRightOrImpl(fn) {
        return this.isRight() ? (0, symbols_1.getInnerValue)(this) : fn();
    }
    ;
    cases.Right.prototype.getRightOr = getRightOrImpl;
    cases.Left.prototype.getRightOr = getRightOrImpl;
    function getLeftImpl() {
        return this.isLeft() ? (0, symbols_1.getInnerValue)(this) : undefined;
    }
    ;
    cases.Right.prototype.getLeft = getLeftImpl;
    cases.Left.prototype.getLeft = getLeftImpl;
    function getLeftOrImpl(fn) {
        return this.isLeft() ? (0, symbols_1.getInnerValue)(this) : fn();
    }
    ;
    cases.Right.prototype.getLeftOr = getLeftOrImpl;
    cases.Left.prototype.getLeftOr = getLeftOrImpl;
    function mapImpl(fn) {
        return this.isRight() ? this.map(fn) : this;
    }
    function mapErrorImpl(fn) {
        return this.isLeft() ? this.mapError(fn) : this;
    }
    cases.Right.prototype.ifRight = mapImpl;
    cases.Right.prototype.mapRight = mapImpl;
    cases.Right.prototype.ifLeft = mapErrorImpl;
    cases.Right.prototype.mapLeft = mapErrorImpl;
    cases.Left.prototype.ifRight = mapImpl;
    cases.Left.prototype.mapRight = mapImpl;
    cases.Left.prototype.ifLeft = mapErrorImpl;
    cases.Left.prototype.mapLeft = mapErrorImpl;
    cases.Right.prototype.toAsync = function () {
        return Async_1.default.Success(this.get());
    };
    cases.Left.prototype.toAsync = function () {
        return Async_1.default.Fail(this.getEither());
    };
    globals.lefts = (ls) => ls.filter((l) => l.isLeft());
    globals.rights = (rs) => rs.filter((r) => r.isRight());
    globals.partition = (lrs) => [
        lrs.filter((l) => l.isLeft()),
        lrs.filter((r) => r.isRight()),
    ];
    globals.collectLefts = (xs) => xs
        .filter((x) => { var _a; return (_a = x.isLeft) === null || _a === void 0 ? void 0 : _a.call(x); })
        .reduce((acc, next) => {
        return acc.mapLeft((ls) => ls.concat(next.getLeft()));
    }, new cases.Left([]));
    globals.collectRights = (xs) => xs
        .filter((x) => { var _a; return (_a = x.isRight) === null || _a === void 0 ? void 0 : _a.call(x); })
        .reduce((acc, next) => {
        return acc.map((rs) => rs.concat(next.getRight()));
    }, new cases.Right([]));
};
const Defs = {
    trivials: ["Right"],
    identities: ["Left"],
    errors: ["Left"],
    pure: "Right",
    left: "Left",
    right: "Right",
    resolve: ["Right"],
    reject: ["Left"],
    overrides: {
        fold: {
            Left: function (fnLeft, fnRight) {
                return fnLeft(this.getLeft());
            },
            Right: function (fnLeft, fnRight) {
                return fnRight(this.get());
            },
        },
    },
};
function defaultConstructor(l, r) {
    return (0, functions_1.isNil)(r) ? this.Left(l) : this.Right(r);
}
const Either = (0, union_1.default)("Either", {
    Left: (x) => x,
    Right: (x) => x,
}, [
    (0, Union_1.Functor)(Defs),
    (0, Union_1.FunctorError)(Defs),
    (0, Union_1.Applicative)(Defs),
    (0, Union_1.Foldable)(Defs),
    (0, Union_1.Monad)(Defs),
    (0, Union_1.Swap)(Defs),
    (0, Union_1.Show)(Defs),
    (0, Union_1.Thenable)(Defs),
    EitherType(),
]).constructors({
    of(x) { return defaultConstructor.bind(this)(x, x); },
    from: defaultConstructor,
    fromNullish: defaultConstructor,
    fromFalsy(l, r) {
        return r ? this.Right(r) : this.Left(l);
    },
    fromPredicate(pred, x) {
        return pred(x) ? this.Right(x) : this.Left(x);
    },
    fromCondition(pred, x) {
        return pred(x) ? this.Right(x) : this.Left(x);
    },
    fromMaybe(m) {
        return m.match({ Just: this.Right, None: this.Left });
    },
    defaultTo(left) {
        return (right) => (right ? this.Right(right) : this.Left(left));
    },
    attempt(fn, ...args) {
        try {
            return this.Right(fn(...args));
        }
        catch (e) {
            return this.Left(e);
        }
    },
    asyncAttempt(fn, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.Right(yield fn(...args));
            }
            catch (e) {
                return this.Left(e);
            }
        });
    },
});
exports.default = Either;
